import { render, staticRenderFns } from "./CoursewareBlockDiscussion.vue?vue&type=template&id=0e25798a&"
import script from "./CoursewareBlockDiscussion.vue?vue&type=script&lang=js&"
export * from "./CoursewareBlockDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports